// TODO: this should be migrated with nomination constants
export enum APPLICATION_STATUS_TYPE {
  // Application
  CREATED = 'CREATED',
  APPLICATION_FEE_PENDING = 'APPLICATION_FEE_PENDING',
  SUBMITTED = 'SUBMITTED',

  // Supervisor
  UNDER_SUPERVISOR = 'UNDER_SUPERVISOR',
  SUPERVISOR_NOMINATED = 'SUPERVISOR_NOMINATED',
  IN_NOMINATION_POOL = 'IN_NOMINATION_POOL',
  PARTNER_NOMINATION_PENDING = 'PARTNER_NOMINATION_PENDING',

  // Assessment
  UNDER_DORPGS = 'UNDER_DORPGS',
  UNDER_DSRC = 'UNDER_DSRC',
  DSRC_ASSESSED = 'DSRC_ASSESSED',

  UNDER_HOD_DOS = 'UNDER_HOD_DOS',

  UNDER_FRCSB = 'UNDER_FRCSB',
  FRCSB_ASSESSED = 'FRCSB_ASSESSED',

  UNDER_GS = 'UNDER_GS',
  GS_ASSESSED = 'GS_ASSESSED',

  UNDER_PANEL = 'UNDER_PANEL',
  PANEL_NOMINATED = 'PANEL_NOMINATED',
  UNDER_INTERVIEW_PANEL = 'UNDER_INTERVIEW_PANEL',

  OFFERED = 'OFFERED',
  UNSUCCESSFUL = 'UNSUCCESSFUL',
  OFFER_PROVISIONING = 'OFFER_PROVISIONING',
  FAILED_PROVISIONING = 'FAILED_PROVISIONING',

  // Registration
  REGISTERED = 'REGISTERED',
  REGISTRATION_FEE_PENDING = 'REGISTRATION_FEE_PENDING',
  REGISTRATION_FEE_SETTLED = 'REGISTRATION_FEE_SETTLED',
  UNDER_REGISTRATION = 'UNDER_REGISTRATION',

  // Others
  RETURNED = 'RETURNED',
  WITHDRAWN = 'WITHDRAWN',
  OVERDUE = 'OVERDUE',
  DECLINED = 'DECLINED',
  LAPSED = 'LAPSED',
  MODIFICATION_FROZEN = 'MODIFICATION_FROZEN',
  CONDITION_MEET_LAPSED = 'CONDITION_MEET_LAPSED',
}

const COMMON_STATUS_DISPLAY_MAP: Partial<
  Record<APPLICATION_STATUS_TYPE, string>
> = {
  // application start
  [APPLICATION_STATUS_TYPE.CREATED]: 'Created',
  [APPLICATION_STATUS_TYPE.SUBMITTED]: ' Submitted',
  [APPLICATION_STATUS_TYPE.MODIFICATION_FROZEN]: ' Submitted',
  [APPLICATION_STATUS_TYPE.APPLICATION_FEE_PENDING]: 'Pending Application Fee',

  // offer
  [APPLICATION_STATUS_TYPE.OFFERED]: 'Offered',

  // registration
  [APPLICATION_STATUS_TYPE.UNDER_REGISTRATION]: 'Under Registration',
  [APPLICATION_STATUS_TYPE.REGISTERED]: 'Registered',
  [APPLICATION_STATUS_TYPE.REGISTRATION_FEE_PENDING]:
    'Pending Registration Fee',
  [APPLICATION_STATUS_TYPE.REGISTRATION_FEE_SETTLED]:
    'Registration Fee Settled',

  // others
  [APPLICATION_STATUS_TYPE.RETURNED]: 'Returned',
  [APPLICATION_STATUS_TYPE.LAPSED]: 'Offer Lapsed',
  [APPLICATION_STATUS_TYPE.CONDITION_MEET_LAPSED]: 'Meet Condition Lapsed',
  [APPLICATION_STATUS_TYPE.WITHDRAWN]: 'Withdrawn',
  [APPLICATION_STATUS_TYPE.UNSUCCESSFUL]: 'Not Considered',
  [APPLICATION_STATUS_TYPE.OVERDUE]: 'Overdue',
};

// For applicant card list display
export const APPLICANT_STATUS_DISPLAY_MAP: Partial<
  Record<APPLICATION_STATUS_TYPE, string>
> = {
  ...Object.keys(COMMON_STATUS_DISPLAY_MAP).reduce<
    Partial<Record<APPLICATION_STATUS_TYPE, string>>
  >((acc, key) => {
    const typedKey = key as keyof typeof APPLICATION_STATUS_TYPE;
    acc[APPLICATION_STATUS_TYPE[typedKey]] =
      COMMON_STATUS_DISPLAY_MAP[typedKey];
    return acc;
  }, {}),
  [APPLICATION_STATUS_TYPE.PARTNER_NOMINATION_PENDING]: 'Under Review',
  [APPLICATION_STATUS_TYPE.UNDER_SUPERVISOR]: 'Under Review',
  [APPLICATION_STATUS_TYPE.SUPERVISOR_NOMINATED]: 'Under Review',
  [APPLICATION_STATUS_TYPE.IN_NOMINATION_POOL]: 'Under Review',
  [APPLICATION_STATUS_TYPE.UNDER_DORPGS]: 'Under Review',
  [APPLICATION_STATUS_TYPE.UNDER_DSRC]: 'Under Review',
  [APPLICATION_STATUS_TYPE.DSRC_ASSESSED]: 'Under Review',
  [APPLICATION_STATUS_TYPE.UNDER_FRCSB]: 'Under Review',
  [APPLICATION_STATUS_TYPE.FRCSB_ASSESSED]: 'Under Review',
  [APPLICATION_STATUS_TYPE.UNDER_GS]: 'Under Review',
  [APPLICATION_STATUS_TYPE.GS_ASSESSED]: 'Under Review',
  [APPLICATION_STATUS_TYPE.UNDER_PANEL]: 'Under Review',
  [APPLICATION_STATUS_TYPE.UNDER_INTERVIEW_PANEL]: 'Under Review',
  [APPLICATION_STATUS_TYPE.PANEL_NOMINATED]: 'Under Review',
  [APPLICATION_STATUS_TYPE.LAPSED]: 'Under Review',
  [APPLICATION_STATUS_TYPE.OFFER_PROVISIONING]: 'Under Review',
  [APPLICATION_STATUS_TYPE.FAILED_PROVISIONING]: 'Under Review',

  [APPLICATION_STATUS_TYPE.DECLINED]: 'Declined',
};

export const SUPERVISOR_STATUS_DISPLAY_MAP: Partial<
  Record<APPLICATION_STATUS_TYPE, string>
> = {
  ...Object.keys(COMMON_STATUS_DISPLAY_MAP).reduce<
    Partial<Record<APPLICATION_STATUS_TYPE, string>>
  >((acc, key) => {
    const typedKey = key as keyof typeof APPLICATION_STATUS_TYPE;
    acc[APPLICATION_STATUS_TYPE[typedKey]] =
      COMMON_STATUS_DISPLAY_MAP[typedKey];
    return acc;
  }, {}),
  [APPLICATION_STATUS_TYPE.CREATED]: 'N/A', // DO NOT DISPLAY
  [APPLICATION_STATUS_TYPE.APPLICATION_FEE_PENDING]: 'N/A', // DO NOT DISPLAY
  [APPLICATION_STATUS_TYPE.SUBMITTED]: 'Pending Nomination',

  [APPLICATION_STATUS_TYPE.UNDER_SUPERVISOR]: 'In Nomination',
  [APPLICATION_STATUS_TYPE.SUPERVISOR_NOMINATED]: 'Nomination Submitted',
  [APPLICATION_STATUS_TYPE.IN_NOMINATION_POOL]: 'In Nomination Pool',

  [APPLICATION_STATUS_TYPE.PARTNER_NOMINATION_PENDING]:
    'Pending Partner Nomination',

  [APPLICATION_STATUS_TYPE.UNDER_DORPGS]: 'Under DoRPgS Assessment',
  [APPLICATION_STATUS_TYPE.UNDER_DSRC]: 'Under D/SRC Assessment',
  [APPLICATION_STATUS_TYPE.DSRC_ASSESSED]: 'Assessed by D/SRC',
  [APPLICATION_STATUS_TYPE.UNDER_HOD_DOS]: 'Under HoD/DoS Endorsement',
  [APPLICATION_STATUS_TYPE.UNDER_FRCSB]: 'Under FRC/SB Assessment',
  [APPLICATION_STATUS_TYPE.FRCSB_ASSESSED]: 'Assessed by FRC/SB',

  [APPLICATION_STATUS_TYPE.UNDER_GS]: 'Under GS Assessment',
  [APPLICATION_STATUS_TYPE.GS_ASSESSED]: 'Assessed by GS',
  [APPLICATION_STATUS_TYPE.UNDER_INTERVIEW_PANEL]: 'Under Interview Panel',
  [APPLICATION_STATUS_TYPE.PANEL_NOMINATED]: 'Nominated by Panel',
  [APPLICATION_STATUS_TYPE.UNDER_PANEL]: 'Under University Panel',

  [APPLICATION_STATUS_TYPE.DECLINED]: 'Applicant Declined Offer',
  [APPLICATION_STATUS_TYPE.OFFER_PROVISIONING]: 'Offer Provisioning',
  [APPLICATION_STATUS_TYPE.FAILED_PROVISIONING]: 'Failed Provisioning',
};

export const ASSESSMENT_STATUS_DISPLAY_MAP: Partial<
  Record<APPLICATION_STATUS_TYPE, string>
> = {
  ...Object.keys(COMMON_STATUS_DISPLAY_MAP).reduce<
    Partial<Record<APPLICATION_STATUS_TYPE, string>>
  >((acc, key) => {
    const typedKey = key as keyof typeof APPLICATION_STATUS_TYPE;
    acc[APPLICATION_STATUS_TYPE[typedKey]] =
      COMMON_STATUS_DISPLAY_MAP[typedKey];
    return acc;
  }, {}),
  [APPLICATION_STATUS_TYPE.PARTNER_NOMINATION_PENDING]:
    'Pending Partner Nomination',
  [APPLICATION_STATUS_TYPE.UNDER_SUPERVISOR]: 'Under Supervisor Assessment',
  [APPLICATION_STATUS_TYPE.SUPERVISOR_NOMINATED]: 'Nominated by Supervisor',
  [APPLICATION_STATUS_TYPE.IN_NOMINATION_POOL]: 'In Nomination Pool',

  [APPLICATION_STATUS_TYPE.UNDER_DORPGS]: 'Under DoRPgS Assessment',
  [APPLICATION_STATUS_TYPE.UNDER_DSRC]: 'Under D/SRC Assessment',
  [APPLICATION_STATUS_TYPE.DSRC_ASSESSED]: 'Assessed by D/SRC',
  [APPLICATION_STATUS_TYPE.UNDER_HOD_DOS]: 'Under HoD/DoS Endorsement',
  [APPLICATION_STATUS_TYPE.UNDER_FRCSB]: 'Under FRC/SB Assessment',
  [APPLICATION_STATUS_TYPE.FRCSB_ASSESSED]: 'Assessed by FRC/SB',

  [APPLICATION_STATUS_TYPE.UNDER_GS]: 'Under GS Assessment',
  [APPLICATION_STATUS_TYPE.GS_ASSESSED]: 'Assessed by GS',
  [APPLICATION_STATUS_TYPE.UNDER_INTERVIEW_PANEL]: 'Under Interview Panel',
  [APPLICATION_STATUS_TYPE.PANEL_NOMINATED]: 'Nominated by Panel',
  [APPLICATION_STATUS_TYPE.UNDER_PANEL]: 'Under University Panel',

  [APPLICATION_STATUS_TYPE.DECLINED]: 'Applicant Declined Offer',
  [APPLICATION_STATUS_TYPE.OFFER_PROVISIONING]: 'Offer Provisioning',
  [APPLICATION_STATUS_TYPE.FAILED_PROVISIONING]: 'Failed Provisioning',
};

// Used for displaying status definition in staff table list
export const APPLICATION_STATUS_EXPLANATION_MAP: Partial<
  Record<APPLICATION_STATUS_TYPE, string>
> = {
  [APPLICATION_STATUS_TYPE.CREATED]:
    'The application has been created, but has not been submitted yet.',

  [APPLICATION_STATUS_TYPE.APPLICATION_FEE_PENDING]:
    'The application fee is pending payment from the applicant.',

  [APPLICATION_STATUS_TYPE.SUBMITTED]:
    'The application fee has been settled, but no nomination has been made yet.',

  [APPLICATION_STATUS_TYPE.PARTNER_NOMINATION_PENDING]:
    'The application is awaiting nomination from a partner university or institution.',

  [APPLICATION_STATUS_TYPE.RETURNED]:
    'The application has been returned to the applicant with advice for modifications.',

  [APPLICATION_STATUS_TYPE.UNDER_SUPERVISOR]:
    'A nomination has been created but not yet submitted by the supervisor.',

  [APPLICATION_STATUS_TYPE.SUPERVISOR_NOMINATED]:
    'The supervisor has nominated the application.',

  [APPLICATION_STATUS_TYPE.IN_NOMINATION_POOL]:
    'The application does not have a proposed supervisor assigned and is currently in the nomination pool.',

  [APPLICATION_STATUS_TYPE.UNDER_DORPGS]:
    'The application is under assessment by DoRPgS.',

  [APPLICATION_STATUS_TYPE.UNDER_DSRC]:
    'The application is being assessed by D/SRC.',

  [APPLICATION_STATUS_TYPE.UNDER_FRCSB]:
    'The application is under assessment by FRC/SB.',

  [APPLICATION_STATUS_TYPE.UNDER_HOD_DOS]:
    'he application is under assessment by HoD/DoS.',

  [APPLICATION_STATUS_TYPE.UNDER_INTERVIEW_PANEL]:
    'The application is under review by the interview panel.',

  [APPLICATION_STATUS_TYPE.UNDER_PANEL]:
    'The application is awaiting a panel meeting for further review.',

  [APPLICATION_STATUS_TYPE.PANEL_NOMINATED]:
    'The panel has approved the nomination of the application.',

  [APPLICATION_STATUS_TYPE.UNDER_GS]:
    'The application is under assessment by GS.',

  [APPLICATION_STATUS_TYPE.OFFER_PROVISIONING]:
    'GS has approved the application, but the offer has not yet been made.',

  [APPLICATION_STATUS_TYPE.FAILED_PROVISIONING]:
    'The application is rejected by DoRPgS or GS, but it has not yet been released.',

  [APPLICATION_STATUS_TYPE.OFFERED]:
    'An offer letter has been issued to the applicant.',

  [APPLICATION_STATUS_TYPE.UNSUCCESSFUL]:
    'The application is rejected and announced by GS.',

  [APPLICATION_STATUS_TYPE.LAPSED]: 'The application has lapsed.',

  [APPLICATION_STATUS_TYPE.CONDITION_MEET_LAPSED]:
    'The offer has lapsed because the conditions were not met.',

  [APPLICATION_STATUS_TYPE.DECLINED]: 'The applicant has declined the offer.',

  [APPLICATION_STATUS_TYPE.REGISTRATION_FEE_PENDING]:
    'The application is waiting for the registration fee payment.',

  [APPLICATION_STATUS_TYPE.REGISTRATION_FEE_SETTLED]:
    'The registration fee has been paid.',

  [APPLICATION_STATUS_TYPE.UNDER_REGISTRATION]:
    'The application is currently under the registration process.',

  [APPLICATION_STATUS_TYPE.REGISTERED]:
    'The application process has been completed successfully.',

  [APPLICATION_STATUS_TYPE.WITHDRAWN]:
    'The application has been withdrawn by the applicant.',

  [APPLICATION_STATUS_TYPE.OVERDUE]: 'The application is past due.',
};
